import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from '@angular/router';
import { ENVIRONMENT } from '../../../../environments/environment.interface';
import { ApiResponse } from '../../../api/api-types/api-response.api';
import { Career, CareerMetadata } from '../../../api/app-types/career.app';
import { ParticipationStatus } from '../../../api/app-types/participation-status.app';
import { CAREER_API } from '../../../api/services/career.service';
import { PaginatedResponse } from '../../pagination/paginated-response';

export const careerPageResolver: ResolveFn<PaginatedResponse<Career>> = async (
	route: ActivatedRouteSnapshot,
	_state: RouterStateSnapshot,
) => {
	const api = inject(CAREER_API);
	const clientId = route.paramMap.get('id');
	const env = inject(ENVIRONMENT);
	if (!clientId) {
		console.warn('No client ID provided');
		return { entities: [], totalEntities: 0, offset: env.pagination.offset, range: env.pagination.range };
	}
	const response = await api.getAllByClient(clientId, env.pagination.offset, env.pagination.range);
	return response;
};

export const careerResolver: ResolveFn<ApiResponse<Career, CareerMetadata> | undefined> = async (
	route: ActivatedRouteSnapshot,
	_state: RouterStateSnapshot,
) => {
	const api = inject(CAREER_API);
	const clientId = route.paramMap.get('id');
	const careerId = route.paramMap.get('careerId');
	if (!clientId || !careerId) {
		console.warn('Client ID or Career ID not provided');
		return undefined;
	}
	const response = await api.getSingle(clientId, careerId);
	return response;
};

export const participationStatusResolver: ResolveFn<PaginatedResponse<ParticipationStatus>> = async (
	_route: ActivatedRouteSnapshot,
	_state: RouterStateSnapshot,
) => {
	const api = inject(CAREER_API);
	const env = inject(ENVIRONMENT);
	const response = await api.getAdmissionStatus(env.pagination.offset, env.pagination.range);
	return response;
};

export const socialSecurityStatusResolver: ResolveFn<PaginatedResponse<ParticipationStatus>> = async (
	_route: ActivatedRouteSnapshot,
	_state: RouterStateSnapshot,
) => {
	const api = inject(CAREER_API);
	const env = inject(ENVIRONMENT);
	const response = await api.getSocialSecurityStatus(env.pagination.offset, env.pagination.range);
	return response;
};
